import { redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";
import { firstAccessAtom } from "@/lib/atoms/first-access-atom";

/**
 * TanStack Router `beforeLoad` guard that ensures the document (CPF) has been
 * filled in the first-access atom before allowing access to subsequent steps.
 * Redirects to /auth/landing if the document is missing.
 */
export const guardFirstAccessDocument = (): void => {
  const { document } = getDefaultStore().get(firstAccessAtom);

  if (!document) {
    redirect({ to: "/auth/landing", throw: true });
  }
};

/**
 * TanStack Router `beforeLoad` guard that ensures the CPF lookup has been
 * completed and an e-mail is present in the first-access atom.
 * Redirects to /auth/landing if the email is missing.
 */
export const guardFirstAccessEmail = (): void => {
  const { email } = getDefaultStore().get(firstAccessAtom);

  if (!email) {
    redirect({ to: "/auth/landing", throw: true });
  }
};
